import {
  Component,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationDialogComponent } from "@app/main/content/confirmation-dialog/confirmation-dialog.component";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { GameSettingsService } from "@app/main/content/game-settings/game-settings.service";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ContentModel } from "@app/main/content/game-settings/popup/content/content.model";
import { AdminApi } from "@lbsdk/*";
import { environment } from "@env/environment";
import * as _ from "lodash";
import { HelperService } from "@app/main/core/services/helper.service";

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ContentComponent implements OnInit {
  dialogTitle: string;
  contentForm: FormGroup;
  action: string;
  selectedIndex: any;

  toggle = false;
  fileNameDialogRef: MatDialogRef<ConfirmationDialogComponent>;
  s3BucketUrl: string;
  embedCode: string;

  @Input("content") content: any;

  showFireworks: boolean = false;
  rewardAmount: number = 100;
  points: number = 0;
  imageFormData: any = null;

  constructor(
    public dialogRef: MatDialogRef<ContentComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private _fuseSplashScreenService: FuseSplashScreenService,
    private _adminApi: AdminApi,
    public gameSettingsService: GameSettingsService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private helperService: HelperService
  ) {
    this.action = data.action;
    if (this.action === "edit") {
      this.dialogTitle = "Content Info";
      this.content = data.popup.content;
      this.content.type =
        this.content && this.content.type
          ? this.content.type.toLocaleLowerCase()
          : "";
      if (this.content.type === "url") {
        this.selectedIndex = 0;
      } else if (this.content.type === "embed") {
        this.selectedIndex = 1;
      } else if (this.content.type === "reward") {
        this.selectedIndex = 2;
        this.content.reward.type =
          this.content.reward.type === "positiveReward";
      } else if (this.content.type === "image") {
        this.selectedIndex = 3;
        this.imageFormData = this.content.data;
      }
    } else {
      this.selectedIndex = 0;
      this.dialogTitle = "Content Info";
      this.content = new ContentModel();
    }
  }

  ngOnInit(): void {
    this.s3BucketUrl = environment.s3BucketUrl;
    this.contentForm = this.createContentForm();
    this.setContentTabTypeValidators();
  }

  createContentForm() {
    return this.formBuilder.group({
      type: [this.content && this.content.type ? this.content.type : ""],
      videoTitle: [
        this.content.embed && this.content.embed.title
          ? this.content.embed.title
          : "",
      ],
      embededCode: [
        this.content.embed && this.content.embed.code
          ? this.content.embed.code
          : "",
      ],
      videoInfo: [
        this.content.embed && this.content.embed.description
          ? this.content.embed.description
          : "",
      ],
      rewardType: [
        this.content.reward && this.content.reward.type
          ? this.content.reward.type
          : "",
      ],
      rewardUrl: [
        this.content.reward &&
        this.content.reward.data &&
        this.content.reward.data.url
          ? this.content.reward.data.url
          : "",
      ],
      isUrl: [
        this.content.reward &&
        this.content.reward.data &&
        this.content.reward.data.isUrl
          ? this.content.reward.data.isUrl
          : "",
      ],
      rewardThumbnail: [
        this.content.reward && this.content.reward.data && (this.content.reward.data.coinIcon || this.content.reward.data.image)
          ? (this.content.reward.data.coinIcon || this.content.reward.data.image)
          : (this.gameSettingsService.defaultCoinIcon && this.gameSettingsService.defaultCoinIcon.value 
              ? this.gameSettingsService.defaultCoinIcon.value 
              : "")
      ],
      rewardArt: [
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.thumbnail && this.content.reward.data.thumbnail.image) || this.content.reward.data.rewardArt)
          ? ((this.content.reward.data.thumbnail && this.content.reward.data.thumbnail.image) || this.content.reward.data.rewardArt)
          : "",
      ],
      points: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        this.content.reward.data.points
          ? this.content.reward.data.points
          : "",
      ],
      isExpand: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        this.content.reward.data.isExpand
          ? this.content.reward.data.isExpand
          : false,
      ],
      thumbnailScale: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.thumbnail && this.content.reward.data.thumbnail.scale) || this.content.reward.data.thumbnailScale)
          ? ((this.content.reward.data.thumbnail && this.content.reward.data.thumbnail.scale) || this.content.reward.data.thumbnailScale)
          : 1.0,
      ],
      rewardBackground: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.background && this.content.reward.data.background.image) || this.content.reward.data.background)
          ? ((this.content.reward.data.background && this.content.reward.data.background.image) || this.content.reward.data.background)
          : "",
      ],
      backgroundScale: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.background && this.content.reward.data.background.scale) || this.content.reward.data.backgroundScale)
          ? ((this.content.reward.data.background && this.content.reward.data.background.scale) || this.content.reward.data.backgroundScale)
          : 1.0,
      ],
      url: [this.content.type === "url" ? this.content.data.link : ""],
      selectedQueId: [
        this.content && this.content.data ? this.content.data.id : "",
      ],
      rewardColor1: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.background && this.content.reward.data.background.color1) || this.content.reward.data.color1)
          ? ((this.content.reward.data.background && this.content.reward.data.background.color1) || this.content.reward.data.color1)
          : null,
      ],
      rewardColor2: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.background && this.content.reward.data.background.color2) || this.content.reward.data.color2)
          ? ((this.content.reward.data.background && this.content.reward.data.background.color2) || this.content.reward.data.color2)
          : null,
      ],
      counterColor1: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.counter && this.content.reward.data.counter.counterColor1) || this.content.reward.data.counterColor1)
          ? ((this.content.reward.data.counter && this.content.reward.data.counter.counterColor1) || this.content.reward.data.counterColor1)
          : null,
      ],
      counterColor2: [
        this.content &&
        this.content.reward &&
        this.content.reward.data &&
        ((this.content.reward.data.counter && this.content.reward.data.counter.counterColor2) || this.content.reward.data.counterColor2)
          ? ((this.content.reward.data.counter && this.content.reward.data.counter.counterColor2) || this.content.reward.data.counterColor2)
          : null,
      ],

      // *QUE related code
      selectedQue: [undefined],
      selectedQuePosition: [undefined],
      // */QUE related code
      queUrl: [undefined],
      playerId: [undefined],
      playerImage: [undefined],
      imageFormButtonText: [undefined],
      imageFormUrl: [
        this.imageFormData && this.imageFormData.buttonTitle
          ? this.imageFormData.buttonTitle
          : undefined,
      ],
      imageFormData: [
        this.imageFormData && this.imageFormData.url
          ? this.imageFormData.url
          : undefined,
      ],
      imageFormImage: [
        this.imageFormData && this.imageFormData.image
          ? this.imageFormData.image.imgSrc
          : undefined,
      ],
      imageFormBackgroundImage: [
        this.imageFormData && this.imageFormData.backgroundImage
          ? this.imageFormData.backgroundImage.imgSrc
          : undefined,
      ],
    });
  }

  uploadImage($event, uploadPath: string, controlName) {
    if ($event.target.files.length) {
      this._fuseSplashScreenService.show();

      // Use image compression before uploading
      this.helperService.compressImage($event.target.files[0]).then(
        (result) => {
          const compressedBlob = result.compressedBlob;

          this.gameSettingsService
            .upload(
              compressedBlob,
              uploadPath,
              this._adminApi.getCurrentToken().id
            )
            .then(
              (response: any) => {
                this.contentForm.patchValue({
                  [`${controlName}`]:
                    response.result.files["file"][0]["providerResponse"].name,
                });
                this._fuseSplashScreenService.hide();
              },
              (error) => {
                this._fuseSplashScreenService.hide();
              }
            );
        },
        (error) => {
          this.fuseSplashScreenService.hide();
        }
      );
    }
  }

  resolveSrc(value: string): string {
    if (!value) {
      return "/assets/images/image-not-found-150x150.png";
    }
    const v = String(value).trim();
    if (/^(data:|https?:|blob:)/i.test(v)) {
      return v;
    }
    if (v.startsWith("/assets/")) {
      return v;
    }
    return this.s3BucketUrl + v;
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  onCompactApply(evt: { blob: Blob; filters: any }, controlName: string) {
    if (!evt || !evt.blob) {
      return;
    }
    this.blobToBase64(evt.blob).then((base64) => {
      this.contentForm.patchValue({ [controlName]: base64 });
    }).catch(() => {
      // ignore read errors
    });
  }

  setContentTabTypeValidators() {
    const url = this.contentForm.get("url");

    const embededCode = this.contentForm.get("embededCode");

    const selectedQue = this.contentForm.get("selectedQue");

    const imageFormButtonText = this.contentForm.get("imageFormButtonText");
    const imageFormUrl = this.contentForm.get("imageFormUrl");
    const imageFormImage = this.contentForm.get("imageFormImage");
    // const imageFormBackgroundImage = this.contentForm.get(
    //   "imageFormBackgroundImage"
    // );
    
    const points = this.contentForm.get("points");

    this.content.type = this.content.type ? this.content.type : "Url";
    if (this.content.type === "Url") {
      this.contentForm.get("url").setValidators([Validators.required]);
    }
    this.contentForm
      .get("type")
      .valueChanges.subscribe((selectedContentTabType) => {
        if (selectedContentTabType === "Url") {
          url.setValidators([Validators.required]);
          embededCode.setValidators(null);
          selectedQue.setValidators(null);
          points.setValidators(null);
        }

        if (selectedContentTabType === "Embed") {
          embededCode.setValidators([Validators.required]);
          url.setValidators(null);
          selectedQue.setValidators(null);
          points.setValidators(null);
        }

        if (selectedContentTabType === "Reward") {
          url.setValidators(null);
          embededCode.setValidators(null);
          selectedQue.setValidators(null);
          points.setValidators([Validators.required]);
          this.setRewardUrlValidator();
        }

        // *QUE related code
        if (selectedContentTabType === "Que") {
          selectedQue.setValidators([Validators.required]);
          url.setValidators(null);
          embededCode.setValidators(null);
          points.setValidators(null);
        }

        if (selectedContentTabType === "Image") {
          imageFormButtonText.setValidators([Validators.required]);
          imageFormUrl.setValidators([Validators.required]);
          imageFormImage.setValidators([Validators.required]);
          // imageFormBackgroundImage.setValidators([Validators.required]);
          embededCode.setValidators(null);
          selectedQue.setValidators(null);
          url.setValidators(null);
          points.setValidators(null);
        } else {
          imageFormButtonText.setValidators(null);
          imageFormUrl.setValidators(null);
          imageFormImage.setValidators(null);
          // imageFormBackgroundImage.setValidators(null);
        }

        imageFormButtonText.updateValueAndValidity();
        imageFormUrl.updateValueAndValidity();
        imageFormImage.updateValueAndValidity();
        // imageFormBackgroundImage.updateValueAndValidity();
        // */QUE related code

        url.updateValueAndValidity();
        embededCode.updateValueAndValidity();
        // *QUE related code
        selectedQue.updateValueAndValidity();
        selectedQue.updateValueAndValidity();
        points.updateValueAndValidity();
        // */QUE related code
      });
  }

  setRewardUrlValidator() {
    const rewardUrl = this.contentForm.get("rewardUrl");
    this.contentForm.get("isUrl").valueChanges.subscribe((isUrl) => {
      if (isUrl) {
        rewardUrl.setValidators([Validators.required]);
      } else {
        rewardUrl.setValidators(null);
      }
      rewardUrl.updateValueAndValidity();
    });
  }

  tabChanged($event?, data?) {
    if ($event !== "edit") {
      this.contentForm.patchValue({ type: $event.tab.textLabel });
    }
  }
  
  handleImageFormDataChange(formData: any) {
    this.contentForm.patchValue({
      imageFormButtonText: formData.buttonTitle,
      imageFormUrl: formData.url,
      imageFormImage: formData.image.imgSrc,
      imageFormBackgroundImage: formData.backgroundImage.imgSrc
    });
    const _formData = this.contentForm.getRawValue();
    const imageFormButtonText = this.contentForm.get("imageFormButtonText");
    const imageFormUrl = this.contentForm.get("imageFormUrl");

    const imageFormImage = this.contentForm.get("imageFormImage");
    // const imageFormBackgroundImage = this.contentForm.get(
    //   "imageFormBackgroundImage"
    // );
    if (
      _formData.imageFormButtonText !== "" &&
      _formData.imageFormUrl !== "" &&
      _formData.imageFormData.image.imgSrc !== "" &&
      _formData.imageFormData.backgroundImage.imgSrc
    ) {
      imageFormButtonText.setValidators(null);
      imageFormUrl.setValidators(null);
      imageFormImage.setValidators(null);
      // imageFormBackgroundImage.setValidators(null);
    } else {
      const imageFormButtonText = this.contentForm.get("imageFormButtonText");
      const imageFormUrl = this.contentForm.get("imageFormUrl");
      imageFormButtonText.setValidators([Validators.required]);
      imageFormUrl.setValidators([Validators.required]);
      imageFormImage.setValidators([Validators.required]);
      // imageFormBackgroundImage.setValidators([Validators.required]);
    }
    imageFormButtonText.updateValueAndValidity();
    imageFormUrl.updateValueAndValidity();
    imageFormImage.updateValueAndValidity();
    // imageFormBackgroundImage.updateValueAndValidity();
    this.contentForm.patchValue({ imageFormData: formData });
  }
}
